import type { SVGProps } from 'react'
import * as React from 'react'

const churnCustomerIcon = (props: SVGProps<SVGSVGElement>) => (
  // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    {/* Door Frame */}
    <path d="M14 3H21V21H14" stroke="#D82C0D" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    {/* Doorknob */}
    <path d="M18 12V12.01" stroke="#D82C0D" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    {/* Person's Head */}
    <path
      d="M9 3C10.1046 3 11 3.89543 11 5C11 6.10457 10.1046 7 9 7C7.89543 7 7 6.10457 7 5C7 3.89543 7.89543 3 9 3Z"
      stroke="#D82C0D"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Torso, Legs & Neck */}
    <path d="M9 7V9M9 9L7 14M7 14L10 14L10 19M7 14L4 16H2" stroke="#D82C0D" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    {/* Arms */}
    <path d="M9 10L12 8L14 10M9 10L6 8L4 10" stroke="#D82C0D" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default churnCustomerIcon
